// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../app/actions/generalActions";
import * as uiHelpers from "./SpecificationsUIHelper";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
} from "../../../../../_metronic/_helpers";
import { useSpecificationsUIContext } from "./SpecificationsUIContext";
import { useFilterObjectsUIContext } from "../pages/FilterObjectsUIContext";
import * as columnFormatters from "./column-formatters";


export function SpecificationsTable({
  reduxName,
  api,
  columns,
  auditList = false,
  showRoomsAction = false,
  haveEditAction = false,
  isFullAccess = false,
  haveDeleteAction = false
}) {
  // Specs UI Context
  const specsUIContext = useSpecificationsUIContext();
  const filterUIContext = useFilterObjectsUIContext();

  const intl = useIntl();

  const specsUIProps = useMemo(() => {
    return {
      queryParams: filterUIContext.queryParams,
      setQueryParams: filterUIContext.setQueryParams,
      openEditSpecificationDialog: specsUIContext.openEditSpecificationDialog,
      openDeleteSpecificationDialog: specsUIContext.openDeleteSpecificationDialog,
      openRecoverDeleteSpecificationDialog: specsUIContext.openRecoverDeleteSpecificationDialog,
      openRoomsDialog: specsUIContext.openRoomsDialog,
      ids: specsUIContext.ids,
      setIds: specsUIContext.setIds,
      parentId: specsUIContext.parentId,
      parentName: specsUIContext.parentName,
      secondParentId: specsUIContext.secondParentId,
      secondParentName: specsUIContext.secondParentName,
    };
  }, [specsUIContext, filterUIContext]);



  // Specs Redux state
  // Getting curret state of products list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state[reduxName] }),
    shallowEqual
  );
  const { totalCount, entities, listLoading, name } = currentState;

  // useEffect(() => {
  if (columns.find(q => q.dataField === "action")) { columns.pop() }

  if (showRoomsAction || haveEditAction || haveDeleteAction) {
    columns.push({
      dataField: "action",
      text: "عملیات",
      // text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openRoomsDialog: specsUIProps.openRoomsDialog, showRoomsAction: showRoomsAction,
        openEditSpecificationDialog: specsUIProps.openEditSpecificationDialog, haveEditAction: (haveEditAction),
        openDeleteSpecificationDialog: specsUIProps.openDeleteSpecificationDialog, haveDeleteAction: (haveDeleteAction && isFullAccess),
        openRecoverDeleteSpecificationDialog: specsUIProps.openRecoverDeleteSpecificationDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    })
  }



  // }, []);

  const dispatch = useDispatch();
  useEffect(() => {

    specsUIProps.setIds([]);
    dispatch(
      actions.fetchObjectsByParentId(
        api,
        name,
        specsUIProps.queryParams,
        specsUIProps.parentId,
        specsUIProps.parentName,
        specsUIProps.secondParentId,
        specsUIProps.secondParentName)
    );

  }, [specsUIProps.queryParams, dispatch, specsUIProps.parentId, specsUIProps.secondParentId]);

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {intl.formatMessage({ id: "SHOW" })} {from} {intl.formatMessage({ id: "TO" })} {to} {intl.formatMessage({ id: "OF" })} {size} {intl.formatMessage({ id: "RESULT" })}
    </span>
  );
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: specsUIProps.queryParams.pageSize,
    page: specsUIProps.queryParams.pageNumber,
    paginationTotalRenderer: customTotal,
  };
  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bordered={false}
                bootstrap4
                remote
                keyField="id"
                data={entities === null ? [] : entities}
                columns={columns}
                defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  specsUIProps.setQueryParams
                )}
                selectRow={getSelectRow({
                  entities,
                  ids: specsUIProps.ids,
                  setIds: specsUIProps.setIds,
                })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
}
